import { useState, useRef } from "react";
import UploadImage from "../components/Utils/UploadImage";
import { toast } from "react-hot-toast";
import { ProjectsEndpoints } from "../Routes/api/Endpoints";
import { useNavigate } from "react-router-dom";
import { useAddProjectMutation } from "../services/auth-services/AuthService";
import { LOGIN_PATH } from "../Routes/navigation/navigationPaths";
import defaultImg from "../assets/implement-2372179_640.jpg";

const useAjoutProjectForm = (
  initialFormState,
  formProps,
  formPropsLinkAndObj
) => {
  const [text, setText] = useState("");
  const [addProspect, { isLoading: isLoadingProjectAdded }] =
    useAddProjectMutation();
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const formRef = useRef(null);
  const [formState, setFormState] = useState(initialFormState);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { id, value, files } = e.target;
    if (files) {
      UploadImage(e, setFormState);
    } else {
      if (id === "number") {
        // Validate phone number
        const phoneNumberRegex = /^[0-9]{9,15}$/;
        const repeatedNumberRegex = /^(\d)\1{8,14}$/;

        if (value.length < 9) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [id]: "Le numéro de téléphone doit comporter au moins 9 chiffres.",
          }));
        } else if (value.length > 15) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [id]: "Le numéro de téléphone doit comporter au maximum 15 chiffres.",
          }));
        } else if (repeatedNumberRegex.test(value)) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [id]: "Le numéro de téléphone ne doit pas être composé que d'un seul chiffre répété.",
          }));
        } else if (!phoneNumberRegex.test(value)) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [id]: "Le numéro de téléphone doit comporter entre 9 et 15 chiffres.",
          }));
        } else {
          setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[id];
            return newErrors;
          });
        }
      }

      setFormState((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const handleTextChange = (value) => {
    setText(value);
    if (errors["text"]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors["text"];
        return newErrors;
      });
    }
  };

  const submitForm = (prospectFormData) => {
      addProspect({
        endpoints: ProjectsEndpoints.postPorteurProjet,
        formData: prospectFormData,
      })
      .unwrap()
      .then((prospectData) => {
        formRef.current.reset();
        setText("");
        setSuccessMessage(
          "Votre projet a été ajouté avec succès. Un email vous a été envoyé, merci de vérifier votre boîte de réception pour les prochaines étapes."
        );
        setTimeout(() => setSuccessMessage(""), 15000);
        setFormState(initialFormState);
        // toast.success(prospectData.message);
        setErrors({});
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      })
      .catch((error) => {
        if (error.status === 403) {
          const formDataObject = {};
          prospectFormData.forEach((value, key) => {
            formDataObject[key] = value;
          });
          localStorage.setItem("formData", JSON.stringify(formDataObject));
          setErrorMessage(
            error?.data?.message || "Une erreur est survenue."
          );
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          const timer = setTimeout(() => {
            navigate(`${LOGIN_PATH}`);
          }, 5000);
          return () => clearTimeout(timer);
        }
        
        setErrorMessage(
          error?.data?.message || "Une erreur est survenue."
        );
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        setTimeout(() => setErrorMessage(""), 15000);
      });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = [
      "name",
      "email",
      "number",
      // "pays",
      "titre",
      "objectif",
      "budget",
    ];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!formState[field]) {
        newErrors[field] = `Le champ ${field} est requis.`;
      }
    });

    if (text.trim() === "") {
      newErrors["text"] = "Le champ description est requis.";
    }

  // Check phone number validation
  const phoneNumberRegex = /^[0-9]{9,15}$/;
  if (!phoneNumberRegex.test(formState["number"])) {
    newErrors["number"] =
      "Le numéro de téléphone doit comporter entre 9 et 15 chiffres.";
  }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const prospectFormData = new FormData();

    // Ajouter les autres champs au formulaire
    Object.entries(formState).forEach(([key, value]) => {
      if (key !== "image") {
        prospectFormData.append(key, value);
      }
    });
    prospectFormData.append("description", text);

    if (formState.image) {
      prospectFormData.append("image", formState.image);
      submitForm(prospectFormData);
    } else {
      fetch(defaultImg)
        .then((res) => res.blob())
        .then((blob) => {
          const defaultFile = new File([blob], "defaultImage.jpg", {
            type: "image/jpeg",
          });
          prospectFormData.append("image", defaultFile);
          submitForm(prospectFormData);
        });
    }
  };

  return {
    text,
    handleTextChange,
    errors,
    formRef,
    formState,
    successMessage,
    errorMessage,
    handleChange,
    handleSubmit,
    isLoadingProjectAdded,
  };
};

export default useAjoutProjectForm;
